import React from 'react';
import '../Blog3Cards/Blog3Cards.scss'
import Blog from "../../components/Blog/Blog";
import RouteLink from '../../components/RouteLink/RouteLink';

const Blog3Cards = () => {
    return (
        <div className='blog3CardsWrapper'>

            <Blog/>
        </div>
    );
};

export default Blog3Cards;
